export default {
  form: {
    display_name: {
      label: 'Nume restaurant',
      placeholder: 'Introduceți numele restaurantului',
      help: 'Folosit pe contractul și facturile dvs.',
    },
    store_address: {
      label: 'Adresa locației',
      placeholder: 'Căutați adresa dvs.',
      help: 'Aceasta este adresa pe care o văd clienții dvs.',
    },
    address: {
      label: 'Adresă',
      placeholder: 'Stradă + număr',
    },
    zip_code: {
      label: 'Cod poștal',
      placeholder: 'Cod poștal',
    },
    city: {
      label: 'Oraș',
      placeholder: 'Oraș',
    },
    state: {
      label: 'Județ',
      placeholder: 'Selectați județul',
    },
    country: {
      label: 'Țară',
      help: 'Pentru a muta restaurantul în altă țară, contactați asistența',
    },
  },
  staff_notice:
    'Personalul magazinului nu poate confirma numele și adresa restaurantului. Vă rugăm să cereți managerului de onboarding să verifice aceste detalii.',
  toasts: {
    saved: 'Detaliile locației au fost salvate',
    error: 'Detaliile locației nu au putut fi salvate',
  },
  buttons: {
    next: 'Următorul',
  },
};
